<template>
    <div class="exam-wrap">
        <div class="box1">
            <div class="sign-login">
                <div class="b_input">
                    <div class="sign-in">准考证号：</div>
                    <div class="sign-input">
                        <el-input v-model="number" placeholder="请输入准考证号"></el-input>
                    </div>
                </div>
                <div class="b_input">
                    <div class="sign-in">证件号码：</div>
                    <div class="sign-input">
                        <el-input v-model="idcard" placeholder="请输入证件号码"></el-input>
                    </div>
                </div>
                <div class="btns" @click="login">
                    <img src="https://www.yitku.com/mock/account_2.png">
                    <img src="https://www.yitku.com/mock/account_3.png">
                </div>
            </div>
        </div>
        <div class="notice">说明：请使用准考证号：11111111111，证件号码:111111111111111111</div>


        <el-dialog title="重要提示" :visible.sync="dialogVisible" width="42%" top="22vh" :close-on-click-modal="false"
            center>
            <div class="d_title">会计人员职业道德规范 </div>
            <div class="d_title">坚持诚信，守法奉公。坚持准则，守责敬业。坚持学习，守正创新。</div>
            <div class="d_title">中华人民共和国刑法</div>
            <div class="d_desc">第二百八十四条　非法使用窃听、窃照专用器材，造成严重后果的，处二年以下有期徒刑、拘役或者管制。</div>　　
            <div class="d_desc">第二百八十四条之一　在法律规定的国家考试中，组织作弊的，处三年以下有期徒刑或者拘役，并处或者单处罚金；情节严重的，处三年以上七年以下有期徒刑，并处罚金。</div>
            <div class="d_desc">为他人实施前款犯罪提供作弊器材或者其他帮助的，依照前款的规定处罚。</div>
            <div class="d_desc">为实施考试作弊行为，向他人非法出售或者提供第一款规定的考试的试题、答案的，依照第一款的规定处罚。</div>
            <div class="d_desc">代替他人或者让他人代替自己参加第一款规定的考试的，处拘役或者管制，并处或者单处罚金。</div>
            <div class="d_notice">考生不得以任何方式传播考试试题</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="goNotice" type="warning">我已阅知上述条款</el-button>
            </span>
        </el-dialog>

    </div>
</template>
<script>
export default {
    data() {
        return {
            dialogVisible: false,
            number: '11111111111',
            idcard: '11111111111',
            paper_id: 0,
        };
    },
    mounted: function () {
        var that = this;
        var query = that.$route.query;
        if (query.paper_id) {
            that.paper_id = query.paper_id;
        }
    },
    methods: {

        login() {
            if (this.number == '') {
                this.$message.warning("准考证号不能为空");
                return false;
            }
            if (this.idcard == '') {
                this.$message.warning("证件号码不能为空");
                return false;
            }
            this.dialogVisible = true;
        },
        goNotice() {
            this.$router.push({
                path: "/guide/account/index",
                query: {
                    paper_id: this.paper_id,
                },
            });
        },
    },
};
</script>
<style scoped>
.d_title {
    height: 38px;
    font-weight: bold;
    font-size: 18px;
    color: #000000;
    line-height: 38px;
    text-align: center;
}

.d_desc {
    line-height: 32px;
    color: #000000;
    text-indent: 32px;
}

.d_notice {
    font-weight: bold;
    font-size: 28px;
    color: #000000;
    text-align: center;
    margin-top: 30px;
}


.exam-wrap {
    background: linear-gradient(0deg, #F5F8FD 0%, #ADCFE8 100%) !important;
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    overflow: hidden;
    flex-direction: column;
}

.notice {
    color: #040000;
    line-height: 65px;
    font-size: 12px;
}

.box1 {
    width: 650px;
    height: 365px;
    background: url('https://www.yitku.com/mock/account_5.png') no-repeat center center;
    background-size: 100%;
    margin: 0 auto;
    padding: 100px;
}

.box1 .sign-login {
    padding: 50px 0 0 160px;
    display: flex;
    flex-direction: column;
}

.box1 .sign-login .b_input {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 15px;
}

.box1 .sign-login .btns {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
    cursor: pointer;
}

.box1 .sign-login .btns img {
    width: 85px;
    height: 30px;
}
</style>